import script from "./HistorialVentas.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorialVentas.vue?vue&type=script&setup=true&lang=js"

import "./HistorialVentas.vue?vue&type=style&index=0&id=83c7112a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83c7112a"]])

export default __exports__